export const CAROUSEL_TEXTS = {
  title: "Recent Disputes",
  subtitle: "Swipe or drag to view more",
  emptyState: "No disputes found",
} as const;

export const SWIPER_CONFIG = {
  spaceBetween: 6,
  grabCursor: true,
  loop: false,
  allowTouchMove: true,
  slidesPerView: "auto" as "auto",
  freeMode: {
    enabled: true,
    sticky: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    enabled: true,
  },
  pagination: {
    clickable: true,
    dynamicBullets: true,
    enabled: true,
  },
  breakpoints: {
    320: {
      spaceBetween: 6,
      slidesPerView: 1.1,
    },
    480: {
      spaceBetween: 6,
      slidesPerView: 1.3,
    },
    640: {
      spaceBetween: 6,
      slidesPerView: 1.6,
    },
    768: {
      spaceBetween: 6,
      slidesPerView: 2.0,
    },
    1024: {
      spaceBetween: 6,
      slidesPerView: 2.5,
    },
    1280: {
      spaceBetween: 6,
      slidesPerView: 2.8,
    },
  },
} as const;
